export enum DEVICE_CTRL_TYPE {
    SINGLE_ASSEMBLE_DEVICE = 6000,
    ASSEMBLE_CABLE,
    UPDATE_CABLE_END,
}